import React, { useState } from 'react';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import { Delete, Edit, Add } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Checkbox,
} from '@material-ui/core';
import { deleteParameter } from './parameterServices';
import { addParameter } from './parameterActions';
import NewAreaParam from './NewAreaParam';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

function ParameterTable({
  parameterList,
  editParameter,
  onOverlay,
  handleSelection,
  removeParameter,
  areaId,
}) {
  const [isModalOpen, toggleModal] = useState(false);
  const [paramToAdd, setParaToAdd] = useState(null);
  const classes = useStyles();

  const addParameterInArea = (parameter) => {
    setParaToAdd(parameter);
    toggleModal(true);
  };

  return (
    <React.Fragment>
      {isModalOpen ? (
        <NewAreaParam
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          areaId={areaId}
          parameterToAdd={paramToAdd}
        />
      ) : null}
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Serial number</TableCell>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Importance</TableCell>
              <TableCell align="left">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {parameterList.map((parameter, index) => (
              <TableRow key={parameter.id}>
                <TableCell component="th" scope="row">
                  {index + 1}
                </TableCell>
                <TableCell align="left">{parameter.name}</TableCell>
                <TableCell align="left">{parameter.importance}</TableCell>
                <TableCell align="left">
                  {onOverlay ? (
                    <IconButton
                      color="primary"
                      onClick={() => addParameterInArea(parameter)}
                    >
                      <Add />
                    </IconButton>
                  ) : (
                    <React.Fragment>
                      <IconButton
                        color="primary"
                        onClick={() => editParameter(parameter.id)}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        color="secondary"
                        onClick={() => removeParameter(parameter)}
                      >
                        <Delete />
                      </IconButton>
                    </React.Fragment>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}

const mapDispatchToProps = (dispatch) => ({
  removeParameter: (parameter) => dispatch(deleteParameter(parameter)),
});

export default connect(null, mapDispatchToProps)(ParameterTable);



// WEBPACK FOOTER //
// ./src/parameter/ParameterTable.js